import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PersonaDto } from '../dto/persona-dto';
import { catchError } from 'rxjs/operators';
import { EvadocEvaluadorDto } from '../dto/evadoc-evaluador-dto';
import { RespuestaDto } from '../dto/respuesta-dto';

@Injectable({
  providedIn: 'root'
})
export class EvaluarDocentexDocenteService {

  url = `${environment.host}/api/evaluador`;

  constructor(private http: HttpClient) {
  }

  obtenerDocentesxDocentes(): Observable<PersonaDto[]> {
    return this.http.get<PersonaDto[]>(`${this.url}/docentes-evaluar`).pipe(catchError(error => {
      console.log('Error service evaluar m-obtenerDocentes', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }

  listarEvaluadorPorPersona(codigo: number): Observable<PersonaDto[]> {
    return this.http.get<PersonaDto[]>(`${this.url}/evaluador/${codigo}`);
  }


  actualizar(parDto: EvadocEvaluadorDto): Observable<RespuestaDto> {

    return this.http.put<RespuestaDto>(`${this.url}/actualizar`, parDto);
  }

  public GuardarEvaluador(par: EvadocEvaluadorDto): Observable<RespuestaDto> {
    return this.http.post<RespuestaDto>(`${this.url}/insertar`, par).pipe(catchError(error => {
      console.log('Error service evaluarDocentexDocente-guardarEvaluador', error);
      if (error instanceof HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
          console.log('Error de cliente');
        } else {
          console.log('Error de servidor');
        }
      }
      return throwError(error);
    }));
  }
}
